import * as yup from 'yup';

export const clientOrderPreExistingContactFormValidation = () =>
  yup.object({
    id: yup.string().required().nullable(),
    functions: yup.array().of(yup.string()).min(1).nullable().required(),
    email: yup.string().email().nullable().required(),
  });
